import {
  LayoutDashboard,
  BookOpen,
  Award,
  User,
  Globe,
  ExternalLink,
  MessageSquare,
  HelpCircle,
  FileText,
  Video,
  Music,
  Image as ImageIcon,
  Calendar,
  Mail,
  Phone,
  MapPin,
  ShoppingCart,
  Heart,
  Star,
  Zap,
  Users,
  Gift,
  Megaphone,
  Home,
  Route,
  CalendarRange,
  CalendarDays,
  PlayCircle,
  FileDown,
  MessageCircleQuestion,
  Rocket,
  LifeBuoy,
  Trophy,
  GraduationCap,
  Code2,
  Layers,
  Tag,
  ClipboardCheck,
  Shield,
  Settings,
  type LucideIcon,
} from 'lucide-react';

/**
 * Shared map of selectable sidebar icons (Lucide name -> component).
 * Used by the global menu (StudentLayout), per-course sidebar rendering,
 * and the appearance editor's icon picker.
 */
export const sidebarIconMap: Record<string, LucideIcon> = {
  LayoutDashboard,
  BookOpen,
  Award,
  User,
  Globe,
  ExternalLink,
  MessageSquare,
  HelpCircle,
  FileText,
  Video,
  Music,
  Image: ImageIcon,
  Calendar,
  Mail,
  Phone,
  MapPin,
  ShoppingCart,
  Heart,
  Star,
  Zap,
  Users,
  Gift,
  Megaphone,
  // Os menus que vêm do banco usam estes nomes (aulas, materiais, dúvidas,
  // projeto final, agenda, central de ajuda); sem eles tudo caía no globo.
  Home,
  Route,
  CalendarRange,
  CalendarDays,
  PlayCircle,
  FileDown,
  MessageCircleQuestion,
  Rocket,
  LifeBuoy,
  Trophy,
  GraduationCap,
  Code2,
  Layers,
  Tag,
  ClipboardCheck,
  Shield,
  Settings,
};

/** Ordered list of icon names for pickers. */
export const sidebarIconNames = Object.keys(sidebarIconMap);

/** Resolve an icon name to a component, falling back to Globe. */
export function resolveSidebarIcon(name?: string | null): LucideIcon {
  return (name && sidebarIconMap[name]) || Globe;
}
